import script from "./InvoiceSection9.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSection9.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSection9.vue?vue&type=style&index=0&id=95237cfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95237cfa"]])

export default __exports__